<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M16.362 11.025A2.341 2.341 0 0 0 14.04 9c-.954 0-1.773.576-2.115 1.35A2.028 2.028 0 0 0 9.9 12.375c0 1.116.909 2.025 2.025 2.025h4.392a1.69 1.69 0 0 0 1.692-1.692 1.703 1.703 0 0 0-1.647-1.683ZM7.65 3.78v1.422C6.084 5.76 4.95 7.245 4.95 9a4.02 4.02 0 0 0 1.35 2.988V10.8h1.35v3.6h-3.6v-1.35h1.395A5.378 5.378 0 0 1 3.6 9a5.388 5.388 0 0 1 4.05-5.22Zm6.678 4.32h-1.377A4.091 4.091 0 0 0 11.7 6.012V7.2h-1.35V3.6h3.6v1.35h-1.395a5.436 5.436 0 0 1 1.773 3.15Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
